export default () => {
  const $component = $('.promo-membership');

  if (!$component.length) {
    return;
  }

  $component.each((i, item) => {
    const $self = $(item),
          $tops = $self.find('.promo-membership-item-top');

    matchHeights($tops);
    $(window).on('resize', () => matchHeights($tops));
  });

  function matchHeights($els) {
    $els.height('auto');
    setTimeout(() => {
      const topHeights = $els.map((i, item) => $(item).height()).toArray(),
            targetHeight = Math.max.apply(Math, topHeights);

      $els.height(targetHeight);
    });
  }
};